import styled from 'vue-styled-components';

export const ChartContainer = styled.div`
  height: 425px;
  margin-bottom: 25px;
`;

export const ChartTitle = styled.h2`
  padding: 20px 0;
`;

export const ChartSubtitle = styled.span`
  color: ${({ theme }) => theme.mainColor};
`;
